import script from "./ListarEmarketingRespativos.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarEmarketingRespativos.vue?vue&type=script&setup=true&lang=js"

import "./ListarEmarketingRespativos.vue?vue&type=style&index=0&id=1560c3cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1560c3cc"]])

export default __exports__